import { inject, Pipe, PipeTransform } from '@angular/core';
import { Factory } from 'app/app.factory';
@Pipe({
    name: 's3Url',
    standalone: true,
})
export class s3UrlPipe implements PipeTransform {
    user: any;
    s3 = inject(Factory).getS3('bespin');

    /**
     * Transform
     *
     * @param value
     * @param {string[]} args
     * @returns {any}
     */

    transform(value: any, args: string[]): any {
        return window.decodeURIComponent(`${this.s3}/${value}`);
    }
}
